import {css} from '@logistics-frontend/blocks/theme/css'
import {theme} from '@logistics-frontend/blocks/theme/theme'

export const classes = {
  sm: css`
    display: none;
    ${theme.breakpoints.down('sm')} {
      display: block;
    }
  `,
  ld: css`
    display: none;
    ${theme.breakpoints.up('md')} {
      display: block;
    }
  `,
}
